import { useEffect, useState } from "react";
import { IMAGES } from "../../constants/images";
import { capitalize } from "../../utils/textFormats";
import { calculatePolygonArea, calculatePolygonLength } from "../../utils/calculateUtils";
import CalculateContainer from "./CalculateContainer";

export default function CalculatedInitialAsessmentParams({
  perimeterLength,
  perimeterArea,
  groupedLineDistance,
  handleInitialAsessmentParams,
  percentage,
  maxAssetRisk,
}) {
  const [isShowMoreInfo, setIsShowMoreInfo] = useState(false);
  const [assetInformation, setAssetInformation] = useState(null);

  const handleSelectAssetCountour = (e) => {
    const selectedFeatures = e?.features || [];

    if (!selectedFeatures.length || (!selectedFeatures[0]?.properties?.assetContour && !selectedFeatures[0]?.properties?.isBuilding)) {
      setAssetInformation(null);
      return;
    }

    const assetLength = calculatePolygonLength(selectedFeatures[0]);
    const assetArea = calculatePolygonArea(selectedFeatures[0]);

    setAssetInformation({
      assetLength: Math.round(assetLength),
      assetArea: Math.round(assetArea),
    });
  };

  useEffect(() => {
    const map = window.map;
    const draw = window.draw;
    if (!map || !draw) return;

    const selectedFeatures = draw.getSelected();
    handleSelectAssetCountour(selectedFeatures);

    map.on("draw.selectionchange", handleSelectAssetCountour);
    map.on("draw.update", handleSelectAssetCountour);
    return () => {
      map.off("draw.selectionchange", handleSelectAssetCountour);
      map.off("draw.update", handleSelectAssetCountour);
    };
  }, []);

  return (
    <CalculateContainer color={maxAssetRisk ? maxAssetRisk.riskMessage.color : "#ffffff"} title="Initial assessment result" handleClick={handleInitialAsessmentParams}>
      <p className="wildfire-risk">{maxAssetRisk.riskMessage.risk} Wildfire Risk</p>
      <p className="wildfire-text">
        The assessment is based on overall wildfire danger and the provided information. {maxAssetRisk.riskMessage.text}
      </p>
      <>
        <button className="show-parameters" onClick={() => setIsShowMoreInfo(!isShowMoreInfo)}>
          <span>More info</span>
          <img src={isShowMoreInfo ? IMAGES.ARROW_DOWN : IMAGES.ARROW_UP} alt="Arrow Up/Down" />
        </button>
        {isShowMoreInfo && <hr className="division-sections" />}
      </>
      {isShowMoreInfo && (
        <>
          <p className="analysed-title">Analysed parameters:</p>
          <ul className="analysed-parameters-info">
            <li>Slope: N/N</li>
            <li>Height: N/N</li>
            <li>Plot perimeter: {perimeterLength + " meters"}</li>
            <li>
              Plot area: {perimeterArea} m<sup>2</sup>
            </li>
            <li>Asset perimeter: {assetInformation ? assetInformation.assetLength + " meters" : " N/N"}</li>
            <li>
              Asset area:
              {assetInformation ? (
                <>
                  {" " + assetInformation.assetArea} m<sup>2</sup>
                </>
              ) : (
                " N/N"
              )}
            </li>
            {groupedLineDistance &&
              Object.entries(groupedLineDistance).map(([k, v]) => (
                <li key={k}>
                  {capitalize(k)} distance: {Math.round(v)} meters / {percentage[k]} %
                </li>
              ))}
          </ul>
        </>
      )}
    </CalculateContainer>
  );
}